var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
var ScrollTabComponent = /** @class */ (function () {
    function ScrollTabComponent(comProv) {
        this.comProv = comProv;
        this.tab_list = [];
        this.display_tyep = '1';
        this.scroll_id = '1';
        this.returnTab = new EventEmitter();
        this.active_tab = 0;
        this.color_list = {};
        this.button_background = '#ff0000';
        this.color_list = this.comProv.getColor();
        this.button_background = this.color_list['button_background'];
    }
    ScrollTabComponent.prototype.ngOnInit = function () {
        this.setActive();
    };
    ScrollTabComponent.prototype.setSwipe = function (direction) {
        if (direction == 2) {
            if ((this.active_tab + 1) >= this.tab_list.length) {
                return;
            }
            this.changeTab(this.active_tab + 1);
        }
        else if (direction == 4) {
            if (this.active_tab <= 0) {
                return;
            }
            this.changeTab(this.active_tab - 1);
        }
    };
    ScrollTabComponent.prototype.changeTab = function (idx) {
        this.active_tab = idx;
        var item = document.getElementById(this.scroll_id + '_tab_' + idx);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        this.setActive();
        this.returnTab.emit(idx);
    };
    ScrollTabComponent.prototype.setActive = function () {
        // カテゴリーが２個以上の場合、選択タブのアクティブカラーを設定
        if (this.tab_list.length <= 1) {
            return;
        }
        for (var i = 0; i < this.tab_list.length; i++) {
            this.tab_list[i]['is_active'] = false;
            this.tab_list[i]['color'] = '#999999';
            this.tab_list[i]['background_color'] = '#ffffff';
            this.tab_list[i]['bottom_color'] = 'transparent';
            if (i == this.active_tab) {
                this.tab_list[i]['is_active'] = true;
                this.tab_list[i]['color'] = this.button_background;
                this.tab_list[i]['background_color'] = this.comProv.getRgba(this.button_background, 0.1);
                this.tab_list[i]['bottom_color'] = this.button_background;
            }
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ScrollTabComponent.prototype, "tab_list", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ScrollTabComponent.prototype, "display_tyep", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ScrollTabComponent.prototype, "scroll_id", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], ScrollTabComponent.prototype, "returnTab", void 0);
    ScrollTabComponent = __decorate([
        Component({
            selector: 'scroll-tab',
            templateUrl: 'scroll-tab.html'
        }),
        __metadata("design:paramtypes", [CommonProvider])
    ], ScrollTabComponent);
    return ScrollTabComponent;
}());
export { ScrollTabComponent };
//# sourceMappingURL=scroll-tab.js.map


// WEBPACK FOOTER //
// ./src/components/scroll-tab/scroll-tab.ts.pre-build-optimizer.js